import { css } from '@emotion/react';
import { ZapTemplate } from '@zapier/authentication';
import { Colors, ServiceIcon, Typography } from '@zapier/design-system';
import { mediaQueries } from '@zapier/identity-utils';
import { useTranslations } from 'next-intl';

import { FeatureItem, FeatureItemList } from '../FeatureItem';

type Props = {
  zapTemplate: ZapTemplate;
};

const rootStyle = css`
  display: grid;
  grid-gap: 30px;
`;

const serviceIconStyle = css`
  display: none;

  ${mediaQueries.tablet} {
    display: grid;
    grid-auto-flow: column;
    grid-gap: 20px;
    justify-content: flex-start;
  }
`;

const titleStyle = css`
  ${Typography.Body1}
  color: ${Colors.GrayWarm10};
  margin-bottom: 30px;
  text-align: center;

  ${mediaQueries.tablet} {
    ${Typography.SectionHeader}
    margin-bottom: 0;
    text-align: left;
  }
`;

export function ZapTemplatePromo({ zapTemplate }: Props) {
  const t = useTranslations('signup-features');
  const isTwoService =
    zapTemplate.tailService &&
    zapTemplate.tailService.id !== zapTemplate.headService.id;

  return (
    <div css={rootStyle}>
      <div css={serviceIconStyle}>
        <ServiceIcon
          hasShadow={true}
          serviceName={zapTemplate.headService.id}
          src={zapTemplate.headService.image}
          size={80}
        />
        {isTwoService && (
          <ServiceIcon
            hasShadow={true}
            // @ts-ignore we ensure tailService can't be null
            serviceName={zapTemplate.tailService.id}
            // @ts-ignore we ensure tailService can't be null
            src={zapTemplate.tailService.image}
            size={80}
          />
        )}
      </div>
      {zapTemplate?.title && <h2 css={titleStyle}>{zapTemplate?.title}</h2>}
      <FeatureItemList>
        <FeatureItem key="1">{t('easy-setup')}</FeatureItem>
        <FeatureItem key="2">{t('free-forever')}</FeatureItem>
        <FeatureItem key="3">{t('trial')}</FeatureItem>
      </FeatureItemList>
    </div>
  );
}
